import React from 'react';
import { Text, View } from 'react-native';
import i18n from 'i18n-js';

import { scale } from '@components/frame';
import { font } from '@styles/fonts';

import { MACHINE_CONTROL_OPTIONS } from '@components/tenantStatus/onboardingWizard/constants';
import { isOtherSelected } from '@components/tenantStatus/onboardingWizard/helpers';
import type { MachinesStepProps } from '@components/tenantStatus/onboardingWizard/types';
import ChipGroup from '@components/tenantStatus/onboardingWizard/components/ChipGroup';
import NumberStepper from '@components/tenantStatus/onboardingWizard/components/NumberStepper';
import WizardInput from '@components/tenantStatus/onboardingWizard/components/WizardInput';

const MachinesStep = ({ C, data, onChange }: MachinesStepProps) => {
  const otherSelected = isOtherSelected(data.selectedControls);

  return (
    <View>
      <Text style={[font['Title 2'], { color: C('Label/Light/Primary'), marginBottom: scale(20) }]}>
        {i18n.t('CNC Machines')}
      </Text>

      <View
        style={{
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: scale(8),
        }}
      >
        <Text style={[font['Subhead 1'], { color: C('Label/Light/Primary') }]}>
          {i18n.t('Number of CNC machines')}
        </Text>
        <Text style={[font['Footnote'], { color: C('Label/Light/Tertiary') }]}>{i18n.t('Optional')}</Text>
      </View>
      <View style={{ marginBottom: scale(20) }}>
        <NumberStepper
          C={C}
          value={data.numberOfMachines}
          onChange={(numberOfMachines) => onChange({ ...data, numberOfMachines })}
          testIDPrefix="onboarding-wizard-machines-stepper"
        />
      </View>

      <View
        style={{
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: scale(8),
        }}
      >
        <Text style={[font['Subhead 1'], { color: C('Label/Light/Primary') }]}>{i18n.t('CNC controls')}</Text>
        <Text style={[font['Footnote'], { color: C('Label/Light/Tertiary') }]}>
          {i18n.t('Optional — select all that apply')}
        </Text>
      </View>
      <ChipGroup
        C={C}
        options={MACHINE_CONTROL_OPTIONS}
        selected={data.selectedControls}
        multiSelect
        onChange={(selectedControls) => onChange({ ...data, selectedControls })}
        testIDPrefix="onboarding-wizard-machines-chip"
      />

      {otherSelected && (
        <WizardInput
          C={C}
          value={data.otherText}
          onChangeText={(otherText: string) => onChange({ ...data, otherText })}
          placeholder={i18n.t('Specify other control...')}
          maxLength={70}
          testID="onboarding-wizard-machines-other-input"
          containerStyle={{ marginTop: scale(8) }}
        />
      )}
    </View>
  );
};

export default MachinesStep;
